import "./logger.js";
import { SinApp } from "./sinapp.js";

let newWorker;

window.onload = () => {
   window.app = new SinApp();

};
